import styled from 'styled-components';

export const TooltipContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  margin-left: -7px;

  div {
    ul {
      list-style: none;
      margin-left: -20px;
    }
  }
`;
